import React from "react";
import { Body, Container, Header, IconContainer, Title } from "./style";

type FormMessageBannerProps = {
    title?: string;
    body?: string;
    icon?: React.ReactNode;
}
export default function FormMessageBanner(props: FormMessageBannerProps) {
    const { title, body, icon } = props;
    return (
        <Container>
            <Header>
                <IconContainer>
                    {icon}
                </IconContainer>
                <Title>
                    {title}
                </Title>
            </Header>
            <Body>
                {body}
            </Body>
        </Container>
    );
}